module.exports = __webpack_public_path__ + "static/media/hang_sound.f9ef283b.ogg";